import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { createControlEquipment, deleteControlEquipment, getCaptureControlEquipments, updateControlEquipment } from "../../api/captures/controlEquipment";
import { ControlEquipmentForm } from "../../types/forms/capture";

export const useCaptureControlEquipment = (captureIdStr?: string) => {
  const queryClient = useQueryClient();
  const captureId = Number(captureIdStr);

  const queryKey = ["capture", captureId, "control-equipment"];

  const result = useQuery({
    queryKey,
    queryFn: () => getCaptureControlEquipments(captureId),
    enabled: !!captureId,
  });

  const createMutation = useMutation({
    mutationFn: (values: ControlEquipmentForm) => createControlEquipment(captureId, values),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey });
    },
  });

  const updateMutation = useMutation({
    mutationFn: ({ equipmentId, values }: { equipmentId: number; values: ControlEquipmentForm }) => updateControlEquipment(captureId, equipmentId, values),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey });
    },
  });

  const deleteMutation = useMutation({
    mutationFn: (equipmentId: number) => deleteControlEquipment(captureId, equipmentId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey });
    },
  });

  return {
    controlEquipmentsData: result.data ?? [],
    isPending: result.isPending,
    isError: result.isError,
    error: result.error,
    createControlEquipment: createMutation.mutateAsync,
    updateControlEquipment: updateMutation.mutateAsync,
    deleteControlEquipment: deleteMutation.mutateAsync,
    isUpdating: createMutation.isPending || updateMutation.isPending || deleteMutation.isPending,
  };
};
